import { z } from "zod";
import {
  addMemberRequestSchema,
  memberSchema,
  updateMemberRequestSchema,
  type AddMemberRequest,
  type UpdateMemberRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createMembersResource(ctx: RequestContext) {
  return {
    list(orgId: string) {
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/members`,
        dataSchema: z.object({ items: z.array(memberSchema) }),
        auth: true,
      });
    },

    add(orgId: string, body: AddMemberRequest) {
      const payload = addMemberRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/members`,
        body: payload,
        dataSchema: memberSchema,
        auth: true,
      });
    },

    update(orgId: string, membershipId: string, body: UpdateMemberRequest) {
      const payload = updateMemberRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "PATCH",
        path: `/orgs/${orgId}/members/${membershipId}`,
        body: payload,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },

    remove(orgId: string, membershipId: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: `/orgs/${orgId}/members/${membershipId}`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },

    leave(membershipId: string) {
      return requestJson(ctx, {
        method: "POST",
        path: `/me/memberships/${membershipId}/leave`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
  };
}
